"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useDidChange } from "@/ui/hooks/lifecycle";
import { useMediaQuery } from "@/ui/hooks/use-media-query";
import { Drawer, DrawerContent, DrawerTitle } from "@/ui/shadcn/drawer";
import { useCartModal } from "@/zustand/storefront";
export const CartAsideDrawer = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const {
    openCartModal,
    closeCartModal,
    isCartModalOpen
  } = useCartModal();
  const isDesktop = useMediaQuery("(min-width: 640px)");
  const pathname = usePathname();
  let t1;
  if ($[0] !== closeCartModal) {
    t1 = () => {
      closeCartModal();
    };
    $[0] = closeCartModal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useDidChange(pathname, t1);
  const t2 = isDesktop ? "right" : "bottom";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DrawerTitle className="sr-only">Shopping cart</DrawerTitle>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== closeCartModal) {
    t4 = () => {
      console.log("Pointer down outside");
      closeCartModal();
    };
    $[3] = closeCartModal;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== openCartModal) {
    t5 = () => {
      openCartModal();
    };
    $[5] = openCartModal;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t4 || $[9] !== t5) {
    t6 = <DrawerContent className="sm:fixed sm:bottom-0 sm:left-auto sm:right-0 sm:top-0 sm:mt-0 sm:flex sm:h-full sm:w-1/2 sm:flex-col sm:overflow-hidden sm:rounded-none sm:bg-white sm:shadow-xl lg:w-1/3" aria-describedby="cart-overlay-description" onPointerDownOutside={t4} onEscapeKeyDown={t5}>{children}</DrawerContent>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isCartModalOpen || $[12] !== t2 || $[13] !== t6) {
    t7 = <Drawer open={isCartModalOpen} shouldScaleBackground={true} direction={t2}>{t3}{t6}</Drawer>;
    $[11] = isCartModalOpen;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};